<!--门店休息设置-->
<template>
  <div class="root-container">
    <el-form label-width="120px">
      <template v-if="!isRegular">
        <el-form-item label="会员姓名:">
          <el-input
            readonly="true"
            v-model="bookInfo.childName"
            style="width: 270px"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择上课日期:">
          <el-date-picker
            style="width: 270px"
            @change="changeDay"
            v-model="bookInfo.dayTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择课程:">
          <el-select
            v-model="bookInfo.storeReleaseLessonId"
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in storeReleaseLessons"
              :key="item.id"
              :label="praseLessonName(item)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="bookInfo.remark" style="width: 200px"></el-input>
        </el-form-item>
      </template>
      <template v-else>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号:" prop="userPhone">
              <el-input
                v-model="bookInfo.userPhone"
                style="width: 270px"
                readonly=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="月龄:" prop="monthC">
              <el-input
                v-model="bookInfo.monthC"
                style="width: 270px"
                readonly=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="会员姓名:" prop="childName">
              <el-input
                v-model="bookInfo.childName"
                style="width: 270px"
                readonly=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别:" prop="gender">
              <el-select
                v-model="bookInfo.gender"
                disabled
                placeholder="请选择"
                style="width: 270px"
              >
                <el-option
                  v-for="item in genderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="type === 'A'">
          <el-form-item label="上课日期:">
            <el-radio-group
              v-model="selectWeekDay"
              @change="onChangeWeekDay"
              style="width: 520px"
            >
              <el-radio-button :label="0">{{
                weekDay[0].label
              }}</el-radio-button>
              <el-radio-button :label="1">{{
                weekDay[1].label
              }}</el-radio-button>
              <el-radio-button :label="2">{{
                weekDay[2].label
              }}</el-radio-button>
              <el-radio-button :label="3">{{
                weekDay[3].label
              }}</el-radio-button>
              <el-radio-button :label="4">{{
                weekDay[4].label
              }}</el-radio-button>
              <el-radio-button :label="5">{{
                weekDay[5].label
              }}</el-radio-button>
              <el-radio-button :label="6">{{
                weekDay[6].label
              }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>
        <template v-if="type === 'B'">
          <el-form-item label="上课日期:">
            <el-select placeholder="请选择" style="width: 270px">
              <el-option
                v-for="item in [
                  { label: '周一', value: 1 },
                  { label: '周二', value: 2 },
                  { label: '周三', value: 3 },
                  { label: '周四', value: 4 },
                  { label: '周五', value: 5 },
                  { label: '周六', value: 6 },
                  { label: '周日', value: 7 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span>至</span>
            <el-select placeholder="请选择" style="width: 270px">
              <el-option
                v-for="item in [
                  { label: '周一', value: 1 },
                  { label: '周二', value: 2 },
                  { label: '周三', value: 3 },
                  { label: '周四', value: 4 },
                  { label: '周五', value: 5 },
                  { label: '周六', value: 6 },
                  { label: '周日', value: 7 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="type === 'B'">
          <el-form-item label="课程业务:" prop="gender">
            <el-select placeholder="请选择" style="width: 270px">
              <el-option
                v-for="item in [
                  { label: 'A业务', value: 1 },
                  { label: 'B业务', value: 2 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="课程:" prop="storeReleaseLessonId">
          <el-select
            v-model="bookInfo.storeReleaseLessonId"
            placeholder="请选择"
            style="width: 270px"
          >
            <el-option
              v-for="item in storeReleaseLessons"
              :key="item.id"
              :label="praseLessonName(item)"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="固定类型:">
          <el-select v-model="regularType" placeholder="请选择" style="width: 270px">
            <el-option
              v-for="item in regularTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="regularType == 1" label="非固定时间段:">
          <el-date-picker style="width: 270px"
            v-model="noRegularStartDay"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="起始日期">
          </el-date-picker>
          <el-date-picker
            v-model="noRegularEndDay"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="bookInfo.remark"
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入内容"
            style="width: 600px"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="onClickBookLesson()">保存</el-button>
    </div>
  </div>
</template>
<script>
import timeUtils from "../../utils/timeUtils";
import globaldata from "../../utils/globaldata";
import { qlDayReleaseLessons } from "../../api/StoreReleaseLesson";
import commonUtils from "../../utils/commonUtils";
import enumsUtil from "../../utils/enumsUtil";
import { adminBookLesson, regulerBook } from "@/api/userBookLesson";
import messageUtils from "../../utils/messageUtils";
import { formatDate } from "../../utils/date";

export default {
  name: "BookLessonForChild",
  props: {
    isVip: Boolean,
    lessonTemplateId: null,
    child: Object,
    vipChild: Object,
    numfrom: Number,
    type: {
      type: String,
      default: "A",
    },
  },
  data() {
    return {
      templateId:undefined,
      bookInfo: {},
      //是否是固定约课
      isRegular: false,
      queryParam: {
        dayTime: "",
        lessonTemplateId: "",
      },
      //店铺发布的课程
      storeReleaseLessons: [],

      selectWeekDay: "",
      monday: timeUtils.getFirstDayOfWeek(new Date()),
      weekDay: [],

      regularType: 0,
      regularTypeOptions: [
        { value: 0, label: "长期固定" },
        { value: 1, label: "临时固定" },
      ],
      noRegularDay: [],
      noRegularStartDay: "",
      noRegularEndDay: "",
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],
    };
  },
  created() {
    console.log("this.numfrom", this.numfrom);
    switch (this.numfrom) {
      case 1:
        this.isRegular = true;
        break;
      case 2:
        this.isRegular = false;
        break;
    }
    this.initData();
  },
  methods: {
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    initData() {
      let monday = timeUtils.getFirstDayOfWeek(new Date());
      this.weekDay = [
        { label: "周一", dayTime: formatDate(monday, "yyyy-MM-dd") },
        {
          label: "周二",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -1),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周三",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -2),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周四",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -3),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周五",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -4),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周六",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -5),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周日",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -6),
            "yyyy-MM-dd"
          ),
        },
      ];
      if (!this.isVip) {
        this.bookInfo.childName = this.child.childName;
        this.bookInfo.userId = this.child.userId;
        this.bookInfo.childId = this.child.id;
        this.bookInfo.userBuyCardId = this.vipChild.id;
        this.bookInfo.remark = this.vipChild.remark;
      } else {
        // this.bookInfo.childName = this.vipChild.childName;
        // this.bookInfo.userId = this.vipChild.userId;
        // this.bookInfo.childId = this.vipChild.childId;
        // this.bookInfo.userBuyCardId = this.vipChild.id;
        this.$set(this.bookInfo, "userPhone", this.vipChild.userPhone);
        this.$set(this.bookInfo, "monthC", this.vipChild.monthC);
        this.$set(this.bookInfo, "childName", this.vipChild.childName);
        this.$set(this.bookInfo, "userId", this.vipChild.userId);
        this.$set(this.bookInfo, "childId", this.vipChild.childId);
        this.$set(this.bookInfo, "userBuyCardId", this.vipChild.id);
        this.$set(this.bookInfo, "remark", this.vipChild.remark);
        this.$set(this.bookInfo, "gender", Number(this.vipChild.gender));
      }
      this.queryParam.lessonTemplateId = this.lessonTemplateId;
    },

    praseLessonName(lesson) {
      if (lesson.lessonTemplateId == enumsUtil.lessonTemplateIdBS()) {
        let tStr =
          timeUtils.transTimeHM(lesson.classStartTime) +
          "~" +
          timeUtils.transTimeHM(lesson.classEndTime);
        let ms = "";
        if (lesson.startMonth < 8) {
          ms = "";
        } else {
          ms = "幼儿";
        }
        return lesson.name + "/" + ms + "(" + tStr + ")";
      } else {
        let tStr =
          timeUtils.transTimeHM(lesson.classStartTime) +
          "~" +
          timeUtils.transTimeHM(lesson.classEndTime);
        return lesson.name + "(" + tStr + ")";
      }
    },

    qlDayReleaseLessons() {
      let dayTime = "";
      if (this.isRegular) {
        dayTime = timeUtils.transDayInt(
          this.weekDay[this.selectWeekDay].dayTime
        );
      } else {
        if (commonUtils.isStringNull(this.bookInfo.dayTime)) {
          return;
        }
        dayTime = timeUtils.transDayInt(this.bookInfo.dayTime);
      }

      let param = {
        dayTime: dayTime,
        lessonTemplateId: this.queryParam.lessonTemplateId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };

      qlDayReleaseLessons(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }

        this.storeReleaseLessons = data;
      });
    },
    changeDay(val) {
      this.storeReleaseLessons = [];
      this.qlDayReleaseLessons();
    },
    changeLessonTemplate(val) {
      this.qlDayReleaseLessons();
    },
    onClickBookLesson() {
      if (this.isRegular) {
        this.onRegularBook();
      } else {
        this.onTempBook();
      }
    },

    /**
     * 临时
     */
    onTempBook() {
      let param = {
        userId: this.bookInfo.userId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        releaseLessonId: this.bookInfo.storeReleaseLessonId,
        userBuyCardId: this.bookInfo.userBuyCardId,
        userChildrenId: this.bookInfo.childId,
        remark: this.bookInfo.remark,
      };
      const loading = this.myLoading();
      adminBookLesson(param).then((response) => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("onBookSuccess");
      });
    },

    /**
     *固定预约
     */
    onRegularBook() {
      let param = {
        templateId:this.templateId,
        releaseLessonId: this.bookInfo.storeReleaseLessonId,
        userBuyCardId: this.bookInfo.userBuyCardId,
        childId: this.bookInfo.childId,
        remark: "固定预约",
        regularType: this.regularType,
        noRegularStartDay: this.noRegularStartDay,
        noRegularEndDay: this.noRegularEndDay,
      };
      const loading = this.myLoading();
      regulerBook(param).then((response) => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("onBookSuccess");
      });
    },

    /**
     * 切换周几
     * @param val
     */
    onChangeWeekDay(val) {
      this.qlDayReleaseLessons();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
/deep/ .el-form-item {
  .el-form-item__content {
    .el-select {
      .el-input {
        .el-input__inner {
          background: #ffffff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/BookLessonForChildThree.vue